import { RegistryItem } from '../RegistryItem';
export class AspectFilterRegistryItem extends RegistryItem {
    parent;
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    filter;
    params;
}
